import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

import { hasPermissionString } from "./helpers";
import { StoreType } from "./types";

interface RequirePermissionProps {
	/** Dynamic permission code, e.g. SETTINGS_PERMISSIONS.WORKCENTERS.VIEW. */
	permission: string;
	/** Where to send a user who lacks the permission. */
	redirectTo?: string;
}

/**
 * Route wrapper that keeps a page unreachable by URL for users who cannot see
 * its menu entry. Hiding the nav item alone is not access control — without
 * this the address bar is still a way in.
 *
 * Safe to render on a cold refresh: the user slice seeds `permissions` from
 * localStorage in its initial state, so the check does not briefly see an
 * empty array and bounce a user who is in fact allowed through.
 */
const RequirePermission = ({
	permission,
	redirectTo = "/",
}: RequirePermissionProps) => {
	const permissions = useSelector(
		(state: StoreType) => state.user?.userData?.permissions
	);

	if (!hasPermissionString(permissions, permission)) {
		return <Navigate to={redirectTo} replace />;
	}

	return <Outlet />;
};

export default RequirePermission;
